import { ActivatedRoute, Router, UrlTree } from '@angular/router';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';

export class QueryParamItem {
  name: string;
  value: string = null;

  constructor(name: string, value: string) {
    this.name = name;
    this.value = value;
  }
}

@Injectable()
export class QueryParamsService {
  private subscriptions: { [key: string]: BehaviorSubject<QueryParamItem> } = {};

  constructor(private router: Router, private route: ActivatedRoute) {
    this.route.queryParams.subscribe((param) => this.processRouteEvent(param));
  }

  observe(queryParamName: string): BehaviorSubject<QueryParamItem> {
    if (!this.subscriptions[queryParamName]) {
      const initialValue = this.readParamFromRoute(queryParamName);
      this.subscriptions[queryParamName] = new BehaviorSubject<QueryParamItem>(new QueryParamItem(queryParamName, initialValue));
    }
    return this.subscriptions[queryParamName];
  }

  destroy(queryParamName: string) {
    if (!this.subscriptions[queryParamName]) {
      return;
    }
    this.subscriptions[queryParamName].unsubscribe();
    delete this.subscriptions[queryParamName];
  }

  navigateByQueryParams(queryParams: [{ [paramname: string]: string }]): void {
    const urlTree = this.router.parseUrl(this.router.url);
    this.updateUrlTreeWithQueryString(urlTree, queryParams);
    this.router.navigateByUrl(this.router.serializeUrl(urlTree));
  }

  generateQueryString(queryParams: [{[paramname: string]: string }]): {[key: string]: string} {
    const urlTree = this.router.parseUrl(this.router.url);
    this.updateUrlTreeWithQueryString(urlTree, queryParams);
    return urlTree.queryParams;
  }

  private updateUrlTreeWithQueryString(urlTree: UrlTree, queryParams: [{[paramname: string]: string }]) {
    queryParams.forEach(param => {
      const paramKey: string = Object.keys(param)[0];
      const value: string = param[paramKey];

      if (value === null || value === '') {
        delete urlTree.queryParams[paramKey];
      } else {
        urlTree.queryParams[paramKey] = value;
      }
    });
  }

  private processRouteEvent(urlParams: {[key: string]: any}) {
    // Obtain the parameters I care
    const keys = Object.keys(this.subscriptions);

    // For each parameter, get the new and old value and only send a new value when it has changed
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const subscription = this.subscriptions[key];

      const oldValue: QueryParamItem = subscription.getValue();
      const newValue = urlParams[key];
      if (newValue !== oldValue.value) {
        subscription.next(new QueryParamItem(key, newValue));
      }

    }
  }

  private readParamFromRoute(param: string): string {
    return this.route.snapshot.queryParams[param];
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/query-params.service.ts